
import { Observable, throwError } from 'rxjs';


// tslint:disable: deprecation
const extractError = (error: any): string => {
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = (body as any).error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  return errMsg;
};

/**
 * Class to be used in any service class to handle common operations
 */
export abstract class BaseService {

  /**
   * Handle errors thrown by Promises
   * @param error - Error received from the service call
   * @param translator - Function to translate the service messages received from the api
   */
  protected handlePromiseError(error:any, translator?: (error: Error) => Error): Promise<string> {
    return Promise.reject(translator ? extractError(translator(error)) : extractError(error));
  }

  /**
   * Handle errors thrown by Observables
   * @param error - Error received from the service call
   * @param translator - Function to translate the service messages received from the api
   */
  protected handleObservableError(error: any, translator?: (error: Error) => Error): Observable<string> {
    return throwError(translator ? extractError(translator(error)) : extractError(error));
  }
}
